module.exports = __webpack_public_path__ + "static/img/record2.a6a0298.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/record2.png
// module id = 921
// module chunks = 1